module.exports = __webpack_public_path__ + "static/media/papp.1fdd2fc7.png";